export class DataProtectionRule {
    id: number;
    name: string;
    isDefault: boolean;

    constructor(rule: DataProtectionRule) {
        this.id = rule.id;
        this.name = rule.name;
        this.isDefault = rule.isDefault;
    }
}
